<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";


export default {
  page: {
    title: "Ayarlar",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "AYARLAR",
      subscriptions:[],
      data:{},
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "AYARLAR LİSTESİ",
          active: true,
        },
      ],
      tabs: [
        { title: 'SMS', route: 'sms-islemleri', icon:"bx bx-mail-send", auth:"admin" },
        { title: 'E-Fatura', route: 'efatura-islemleri', icon:"bx bx-file", auth:"admin" },
        { title: 'Santral', route: 'santral-islemleri', icon:"bx bx-support", auth:"admin" },
        { title: 'Sanal Pos', route: 'sanal-pos-islemleri', icon:"bx bx-credit-card", auth:"admin" },
        { title: 'Araç Takip', route: 'arac-takip', icon:"bx bx-car", auth:"admin" },
        { title: 'T. Telekom Vae', route: 'vae', icon:"bx bx-extension", auth:"admin" },
      ],
    };
  },
  computed:{
      routeIsIndex(){
        return  this.$route.name == 'entegrasyonlar';
      }
  },
  methods:{
    checkRole(role){
       
      if(role){
          if(role.indexOf('|')){
              return role.split('|').includes(this.roleName)
          }
      }
      return true;
    },
    link({ route }){
      this.$router.push({ name:route });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row margin-auto" v-if="routeIsIndex">
      <div class="col-md-4"  
            v-for="(tab,i) in tabs"
            :key="i">
        <div class="card mini-stats-wid" @click="link(tab)">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-grow-1">
                <h4 class="mb-0">{{ tab.title }}</h4>
                <span class="badge rounded-pill bg-success">Aktif</span>
              </div>
              <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"><span class="avatar-title"><i class="font-size-24" :class="`${tab.icon}`"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
        <div class="col-xl-12">
            <div class="card">
               <ul class="nav nav-tabs nav-justified nav-tabs-custom" role="tablist">
                  <li
                    v-for="(tab,i) in tabs"
                    :key="i"
                    role="presentation"
                    class="nav-item"
                  >
                    <router-link
                      v-if="checkRole(tab.auth)"
                      :to='{ name: tab.route  }'
                      class="nav-link"
                      active-class="active"
                      exact
                    > 
                      <span class="font-weight-bold">{{ tab.title }}</span>
                    </router-link>
                   </li> 
                </ul>
            </div> <!-- end card-->
            <router-view  />
        </div> <!-- end col -->
    </div>
    <!-- end row-->
  </Layout>
</template>